import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4bc8cab5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-content" }
const _hoisted_2 = { class: "option-group" }
const _hoisted_3 = { class: "option-label" }
const _hoisted_4 = { class: "form-label" }
const _hoisted_5 = { class: "form-label" }

import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import type { SecuritySubSettings } from '@/views/dashboard/_components/group-policy-settings/group-policy-settings.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'internet-protection',
  props: {
  modelValue: {
    type: Object as PropType<SecuritySubSettings>,
    required: true
  },
  readonly: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props

const emits = __emit

const strategy = computed({
  get: () => props.modelValue,
  set: (val) => emits('update:modelValue', val)
})

function handleChange() {
  emits('change')
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('groupPolicySettings.netDlProtectTitle')), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('groupPolicySettings.netDlRemindHow')), 1),
      _createVNode(_component_el_radio_group, {
        modelValue: strategy.value.download_always_remind,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((strategy.value.download_always_remind) = $event)),
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio, {
            class: "option-row",
            label: 1
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.netDlRemindAlways')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_radio, {
            class: "option-row",
            label: 0
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.netDlRemindDangerOnly')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('groupPolicySettings.netDlAfterVirusTitle')), 1),
      _createVNode(_component_el_radio_group, {
        modelValue: strategy.value.download_auto_delete,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((strategy.value.download_auto_delete) = $event)),
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio, {
            class: "option-row",
            label: 0
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.netDlAskHandle')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_radio, {
            class: "option-row",
            label: 1
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.netDlAutoDeleteRec')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ])
  ]))
}
}

})